/**
 * Shared theme colors - used by Vuetify and alert/SweetAlert so button colors stay consistent.
 * Update here to change primary/secondary/success etc. across the app.
 */
export const themeColors = {
  primary: "#5b39c9",
  secondary: "#35378d",
  accent: "#8c9eff",
  info: "#00b0ff",
  success: "#00c853",
  warning: "#f0b000",
  error: "#f44336",
  /** Neutral grey for cancel/secondary buttons */
  cancel: "#757575",
};
